import { Box, Stack, Typography } from '@mui/material';
import React from 'react';
import { FormatNumber, glb_sv } from 'src/utils';
import ButtonAction from 'src/components/Button.js/SaveButton';
import Iconify from 'src/components/iconify';
import { useTranslation } from 'react-i18next';
import Label from 'src/components/label';

const STATUS_COLOR = {
    0: 'secondary',
    1: 'success',
    2: 'warning',
    3: 'info',
    4: 'error',
    5: 'success',
    6: 'warning',
    7: 'success',
};

const ItemRow = ({
    child,
    item,
    dataRowSelect,
    setOpenDrawerSidebar,
    setOpenChangeRequestDevice,
    dataTakeRef,
    setVisibleTakDevice,
    setVisiblePutDevice,
}) => {
    const { t } = useTranslation();
    const user = glb_sv.userInfo;
    return (
        <fieldset
            disabled={child.cell_qty < child.qty && child.status == 0}
            style={{
                border: 0,
                padding: 0,
                margin: 0,
                width: '100%',
                opacity: child.cell_qty < child.qty && child.status == 0 ? 0.5 : 1, // làm toàn bộ mờ đi
                color: child.cell_qty < child.qty && child.status == 0 ? 'gray' : '',
                pointerEvents: child.cell_qty < child.qty && child.status == 0 ? 'none' : '',
            }}
        >
            <Stack direction="row" alignItems="center" spacing={2} sx={{ p: 1, borderBottom: '1px solid #eee' }}>
                <img
                    src={
                        child.img_device
                            ? glb_sv.urlGetProductImage(child.img_device)
                            : glb_sv.urlGetProductImage(child.pic_device)
                    }
                    alt={child.device_nm}
                    style={{
                        width: 40,
                        height: 40,
                        borderRadius: 4,
                        objectFit: 'cover',
                    }}
                />
                <Stack flex={1} spacing={0.5}>
                    <Typography variant="caption" sx={{ color: 'text.disabled', fontWeight: 600, lineHeight: 1 }}>
                        {child.device_cd}
                    </Typography>
                    <Typography variant="subtitle2" noWrap sx={{ fontSize: '0.9rem', fontWeight: 'bold' }}>
                        {child.device_nm}
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                        {`${child.cabinet_nm} / ${child.drawer_nm} / Ô [${child.cell_lc.row},${child.cell_lc.column}]`}
                    </Typography>
                </Stack>
                <Stack alignItems="flex-end" spacing={0.5}>
                    <Box sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
                        <Typography
                            variant="caption"
                            color={child.bussiness === 'etk' ? 'primary.main' : 'secondary.main'}
                        >
                            {child.bussiness_nm}
                        </Typography>
                        <Label color={STATUS_COLOR[child.status]}>{child.status_nm}</Label>{' '}
                    </Box>
                    <Box sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
                        <Typography variant="body2" fontWeight={600}>
                            {FormatNumber(child.price_request_device)}
                        </Typography>

                        <Typography variant="body2" fontWeight={600}>
                            x{child.qty}
                        </Typography>
                    </Box>

                    {child.status == '0' && ['1', '2'].includes(item.status) && item.user_request_id == user?.id && (
                        <Stack
                            padding="checkbox"
                            sx={{
                                position: 'sticky',
                                right: 0,
                                backgroundColor: '#f4f6f8',
                                zIndex: 3,
                            }}
                        >
                            <ButtonAction
                                type="other"
                                title={t('take')}
                                color={'primary'}
                                startIcon={<Iconify color="primary" icon="mdi:package-variant" />}
                                onClick={() => {
                                    setOpenDrawerSidebar(true);
                                    dataRowSelect.current = {
                                        bussiness: child.bussiness,
                                        note: item.note,
                                        id: child.id,
                                        device: {
                                            ...child,
                                        },
                                    };
                                }}
                            />
                        </Stack>
                    )}

                    <Stack spacing={0.5}>
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'center',
                                alignItems: 'center',
                                gap: 2,
                            }}
                        >
                            {['1', '4', '5'].includes(child?.status) && child?.qty_have_return < child?.qty && (
                                <ButtonAction
                                    type="other"
                                    title={t('request_change_device')}
                                    color={'primary'}
                                    startIcon={<Iconify color="primary" icon="mdi:package-variant" />}
                                    disabled={!['0', '13', '12'].includes(child?.transaction_status)}
                                    onClick={() => {
                                        setOpenChangeRequestDevice(true);
                                        dataRowSelect.current = {
                                            bussiness: child.bussiness,
                                            note: item.note,
                                            id: child.id,
                                            device: {
                                                ...child,
                                            },
                                        };
                                    }}
                                />
                            )}
                            {child.status == '3' && (
                                <ButtonAction
                                    type="other"
                                    title={t('take_device')}
                                    color={'primary'}
                                    startIcon={<Iconify color="primary" icon="mdi:package-variant" />}
                                    onClick={() => {
                                        setVisibleTakDevice(true);
                                        dataTakeRef.current = child.id;
                                    }}
                                />
                            )}
                            {['1', '5'].includes(child?.status) && child?.qty_have_return < child?.qty && (
                                <ButtonAction
                                    type="other"
                                    title={t('request_review_device')}
                                    color={'primary'}
                                    startIcon={<Iconify color="primary" icon="mdi:package-variant" />}
                                    onClick={() => {
                                        setVisiblePutDevice(true);
                                        dataRowSelect.current = child;
                                    }}
                                />
                            )}
                        </Box>
                    </Stack>
                </Stack>
            </Stack>
        </fieldset>
    );
};

export default ItemRow;
